import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const IsNotBefore = ({ property, filter, onChange }) => {  

  const PropertyComponent = resolveComponentForOperator(property.type, 'IS_NOT_BEFORE')

  return (
    <div>
      <PropertyComponent
        property={property}
        filter={filter}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default IsNotBefore
